import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=461eeb5b"
import script from "./EventDialog.vue?vue&type=script&lang=js"
export * from "./EventDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDialog.vue?vue&type=style&index=0&id=461eeb5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports